// extracted by mini-css-extract-plugin
export default {"landingPage":"LandingPage_landingPage__8-bxL","main":"LandingPage_main__KrAyt","ctaButton":"LandingPage_ctaButton__W6tSm","footer":"LandingPage_footer__WdWFd"};